module.exports = __webpack_public_path__ + "img/norm-3.f309567.png";